import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type StoreSearchFilterProps = {
    storeFeature: string;
    active: boolean;
    onToggle: (filter: string) => void;
};

const StoreSearchFilter = ({
    storeFeature,
    active,
    onToggle
}: StoreSearchFilterProps) => {
    const { t } = useGranite();

    const handleOnChange = () => onToggle(storeFeature);

    return (
        <li className={"store-search-filters__filter"}>
            <input
                className={"ml-1"}
                id={`storeSearchFilter--${storeFeature}`}
                type="checkbox"
                checked={active}
                onChange={handleOnChange}
            />
            <label
                className={"m-0"}
                htmlFor={`storeSearchFilter--${storeFeature}`}
            >
                {t(`form.searchstore.filter.${storeFeature}`)}
            </label>
        </li>
    );
};

export { StoreSearchFilter };
